export default __webpack_public_path__ + "62bf4a15bfbeb87dbea045ccb9506b1a.svg";